export default __webpack_public_path__ + "static/media/jost-800-heavy.c03a6668.woff";